import { Chatmessage, ChatmessageThread } from 'simpleloan_api'

export function getUserName(message: Chatmessage) {
  return message.role_user_msg === 'admin' ? 'Техподдержка Inpocket' : message.username
}


export function getThreadUserName(thread: ChatmessageThread) {
  return thread.role_user_msg === 'admin' ? 'Техподдержка Inpocket' : thread.latest_last_name
}